/**
 * Fragment de routes du paquet v8c-p03-webhooks-signature-ecrans (vague V8c, règle R2 du découpage V4–V11 : un fragment
 * par paquet). Composants chargés à la demande (règle de chargement du registre). Routes neuves, aucun remplacement du
 * socle :
 *  - `/org/webhooks` → organisation-webhooks ; `/org/webhooks/:webhookId` → organisation-webhook-fiche ;
 *    `/org/webhooks/:webhookId/modifier` → dialogue-modifier-webhook-organisation ; `/org/creer-webhook` →
 *    dialogue-creer-webhook-organisation (pas sous `/org/webhooks/…`, qui chevaucherait la fiche) ;
 *  - `/org/signature-applications` → organisation-signature-applications (`?cle=` : clé choisie) ;
 *    `/org/enregistrer-cle-de-signature` → dialogue-cle-de-signature ; `/org/signature-applications/:cleId/remplacer` →
 *    dialogue-remplacer-cle-de-signature.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const OrganisationWebhooks = lazy(() => import('../ecrans/v8c/webhooks/OrganisationWebhooks'))
const OrganisationWebhookFiche = lazy(() => import('../ecrans/v8c/webhooks/OrganisationWebhookFiche'))
const DialogueCreerWebhook = lazy(() => import('../ecrans/v8c/webhooks/DialogueCreerWebhook'))
const DialogueModifierWebhook = lazy(() => import('../ecrans/v8c/webhooks/DialogueModifierWebhook'))
const OrganisationSignatureApplications = lazy(() => import('../ecrans/v8c/webhooks/OrganisationSignatureApplications'))
const DialogueCleDeSignature = lazy(() => import('../ecrans/v8c/webhooks/DialogueCleDeSignature'))
const DialogueRemplacerCleDeSignature = lazy(() => import('../ecrans/v8c/webhooks/DialogueRemplacerCleDeSignature'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v8c-webhooks',
  routes: [
    { chemin: '/org/webhooks', element: ecran(OrganisationWebhooks) },
    { chemin: '/org/creer-webhook', element: ecran(DialogueCreerWebhook) },
    { chemin: '/org/webhooks/:webhookId', element: ecran(OrganisationWebhookFiche) },
    { chemin: '/org/webhooks/:webhookId/modifier', element: ecran(DialogueModifierWebhook) },
    { chemin: '/org/signature-applications', element: ecran(OrganisationSignatureApplications) },
    { chemin: '/org/enregistrer-cle-de-signature', element: ecran(DialogueCleDeSignature) },
    { chemin: '/org/signature-applications/:cleId/remplacer', element: ecran(DialogueRemplacerCleDeSignature) },
  ],
}
